import { dateToLocalizedString } from '@standardnotes/snjs';
import { getIntlLocale, isDateLocalizationEnabled } from '@/Utils/DateLocale';
export function capitalizeForSentenceStart(text) {
    if (!text || !isDateLocalizationEnabled()) {
        return text;
    }
    const locale = getIntlLocale();
    const firstCharacter = text[0];
    if (firstCharacter.toLocaleUpperCase(locale) === firstCharacter) {
        return text;
    }
    if (firstCharacter.toLocaleLowerCase(locale) === firstCharacter) {
        return firstCharacter.toLocaleUpperCase(locale) + text.slice(1);
    }
    return text;
}
const dateTimeFormatters = new Map();
function getDateTimeFormatter(locale, options) {
    const key = `${locale !== null && locale !== void 0 ? locale : ''}|${JSON.stringify(options)}`;
    let formatter = dateTimeFormatters.get(key);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat(locale, options);
        dateTimeFormatters.set(key, formatter);
    }
    return formatter;
}
export function formatDateTime(date, options = {}) {
    return getDateTimeFormatter(getIntlLocale(), options).format(date);
}
export function formatItemDate(date) {
    return dateToLocalizedString(date);
}
export function formatItemDateForSentenceStart(date) {
    return capitalizeForSentenceStart(formatItemDate(date));
}
export function formatDateAndTimeForNoteTitle(date, includeTime = true) {
    return capitalizeForSentenceStart(formatDateAndTimeForNote(date, includeTime));
}
const noteDateOptions = {
    weekday: 'long',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
};
function formatDateAtTime(date, dateOptions) {
    if (isDateLocalizationEnabled()) {
        return formatDateTime(date, { ...dateOptions, hour: 'numeric', minute: '2-digit' });
    }
    return `${formatDateTime(date, dateOptions)} at ${dateToHoursAndMinutesTimeString(date)}`;
}
export function formatDateAndTimeForNote(date, includeTime = true) {
    return includeTime ? formatDateAtTime(date, noteDateOptions) : formatDateTime(date, noteDateOptions);
}
export function formatDateForContextMenu(date) {
    if (!date) {
        return undefined;
    }
    if (!isDateLocalizationEnabled()) {
        return `${date.toDateString()} ${date.toLocaleTimeString()}`;
    }
    const datePart = formatDateTime(date, { weekday: 'short', month: 'short', day: '2-digit', year: 'numeric' });
    return `${datePart} ${date.toLocaleTimeString(getIntlLocale())}`;
}
export function formatDefaultDateTime(date) {
    return date.toLocaleString(getIntlLocale());
}
export function formatSessionAccessDate(date) {
    return formatDateTime(date, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
        hour: 'numeric',
        minute: 'numeric',
    });
}
export function formatMonthAndYear(date) {
    return formatDateTime(date, {
        month: 'long',
        year: 'numeric',
    });
}
export function formatDateOnlyString(date) {
    return formatDateTime(date);
}
export function dateToStringStyle1(date) {
    return formatDateAtTime(date, { year: 'numeric', month: 'numeric', day: 'numeric' });
}
export function dateToHoursAndMinutesTimeString(date) {
    return formatDateTime(date, { timeStyle: 'short' });
}
